<template>
  <div class="changeSeason">
    <h3 @click.stop="showDropList" class="gameTitle">
      {{ seasonData[currentIndex]?.name }}
      <svg t="1686550261648" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
        p-id="6048" width="32" height="32">
        <path d="M213.333333 341.333333h597.333334l-298.666667 384z" p-id="6049" fill="#58ABF6"></path>
      </svg>
    </h3>
    <ul v-if="isShow">
      <li :class="[item.isActive ? 'active' : '']" v-for="(item, index) in seasonData" @click="change(index)">
        {{ item?.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { queryHistoryCup } from "@/api/winterGame";
import { formatDate, formatMonthDate } from "@/util/util";
import { Toast } from "vant";

export default {
  name: "changeSeason",
  props: {
    isShowDropList: {
      // 旋转角度
      type: Boolean,
      default: false,
    },
    historyList: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      isShow: false,
      currentIndex: 0,
      preIndex: 0,
      seasonData: [],
    };
  },
  mounted() {
    this.initData();
    //设置当前的tempFlag
    let obj = JSON.parse(localStorage.getItem("teamInfo"));
    let flag = obj.title;
    localStorage.setItem("tempFlag", flag);
  },
  methods: {
    hideDropList() {
      this.isShow = false;
    },
    initData() {
      let seasonData = [];
      this.historyList.forEach((item, index) => {
        let isActive = false;
        if (item.isHistoryCup === 0) {
          this.currentIndex = index;
          isActive = true;
        }

        seasonData.push({
          name: item.cupName.slice(3),
          isActive,
          originData: item,
          title: item.title
        });
      });
      this.seasonData = seasonData;
    },

    showDropList() {
      this.isShow = true;
    },
    promiseChangeFlag(item) {
      return new Promise((resolve, reject) => {
        if (item.title) {
          localStorage.setItem("tempFlag", item.title);
          resolve("");
        } else {
          reject("");
        }
      });
    },
    change(index) {
      let preItem = this.seasonData[this.preIndex];
      preItem.isActive = false;
      this.$set(this.seasonData, this.preIndex, preItem);
      let item = this.seasonData[index];
      item.isActive = true;
      this.$set(this.seasonData, index, item);
      this.preIndex = index;
      this.currentIndex = index;
      this.isShow = false;
      //TODO 需要根据赛季进行增加修改

      // let obj = JSON.parse(localStorage.getItem("teamInfo"));
      // if (obj.title == "2023_spring") {
      //   let flag = "2023_summer";
      //   localStorage.setItem("tempFlag", flag);
      // } else if (obj.title === "2023_summer") {
      //   let flag = "2023_spring";
      //   localStorage.setItem("tempFlag", flag);
      // }
      //保证本地存储内的变量被修改了，否则海报赛季可能不对！
      console.log('itemxxx', item);
      this.promiseChangeFlag(item)
        .then((res) => {
          if (item.originData.isHistoryCup === 1) {
            this.$emit("toHistoryResult", item.originData);
          }
        })
        .catch((error) => {
          Toast("请重试！");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.changeSeason {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 32px;

  h3 {
    margin: 0;
    padding: 0;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #58abf6;
    line-height: 56px;
    text-align: center;
    width: 260px;
    height: 56px;
    background: #e4f1fd;
    border-radius: 34px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 32px;
    }
  }

  ul {
    position: absolute;
    top: 56px;
    z-index: 10;
    width: 260px;
    max-height: 202px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    border: 1px solid #e6e6e6;
    overflow: auto;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #323232;
    line-height: 40px;
    text-align: center;
    padding: 24px 0 24px 0;

    li {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      &.active {
        color: #58abf6;
      }
    }
  }
}
</style>
